module.exports = __webpack_public_path__ + "img/Logo.c066ac11.svg";